(function () {
  if (window.playPauseAudio) return;

  function lazyAudio(url) {
    var audio = new Audio();
    audio.preload = 'none';
    audio.src = url;
    return audio;
  }

  var soniloveyou = lazyAudio('https://cdn.shopify.com/s/files/1/0567/7052/7319/files/soniloveyou.mp3');
  var sonrire = lazyAudio('https://cdn.shopify.com/s/files/1/0567/7052/7319/files/sonrire.mp3');
  var sonperenoel = lazyAudio('https://cdn.shopify.com/s/files/1/0567/7052/7319/files/sonperenoel.mp3');
  var sonjappement = lazyAudio('https://cdn.shopify.com/s/files/1/0567/7052/7319/files/sonjappement.mp3');
  var sonhushlittlebaby = lazyAudio('https://cdn.shopify.com/s/files/1/0567/7052/7319/files/sonhushlittlebaby.mp3');
  var sonhappybirthday = lazyAudio('https://cdn.shopify.com/s/files/1/0567/7052/7319/files/sonhappybirthday.mp3');
  var sonenregistrable = lazyAudio('https://cdn.shopify.com/s/files/1/0567/7052/7319/files/sonenregistrable.mp3');
  var sonchat = lazyAudio('https://cdn.shopify.com/s/files/1/0567/7052/7319/files/sonchat.mp3');
  var sonbaiser = lazyAudio('https://cdn.shopify.com/s/files/1/0567/7052/7319/files/sonbaiser.mp3');
  var sonvache = lazyAudio('https://cdn.shopify.com/s/files/1/0567/7052/7319/files/sonvache.mp3');

  var audioMap = {
    soniloveyou: soniloveyou,
    'son-i-love-you': soniloveyou,
    sonrire: sonrire,
    sonperenoel: sonperenoel,
    'son-pere-noel': sonperenoel,
    sonjappement: sonjappement,
    sonhushlittlebaby: sonhushlittlebaby,
    'son-hush-little-baby': sonhushlittlebaby,
    sonhappybirthday: sonhappybirthday,
    'son-happy-birthday': sonhappybirthday,
    sonenregistrable: sonenregistrable,
    sonchat: sonchat,
    sonbaiser: sonbaiser,
    sonvache: sonvache
  };

  window.soniloveyou = soniloveyou;
  window.sonrire = sonrire;
  window.sonperenoel = sonperenoel;
  window.sonjappement = sonjappement;
  window.sonhushlittlebaby = sonhushlittlebaby;
  window.sonhappybirthday = sonhappybirthday;
  window.sonenregistrable = sonenregistrable;
  window.sonchat = sonchat;
  window.sonbaiser = sonbaiser;
  window.sonvache = sonvache;
  window.audioMap = audioMap;

  var currentAudio = null;

  window.playPauseAudio = function (x) {
    var audio = typeof x === 'string' ? audioMap[x] || window[x] || null : x;
    if (!audio) return;
    if (currentAudio && !currentAudio.paused) currentAudio.pause();
    if (currentAudio !== audio) {
      audio.play();
      currentAudio = audio;
    } else {
      currentAudio = null;
    }
  };
})();
